module.exports = __webpack_public_path__ + "static/wingsIcon-457c471e34e03904a925a27da81ffed8.png";